<div class="coupon full no-clickable">
  <div class="coupon-row coupon-image" [ngStyle]="{ 'background-image': 'url(' + item.logoUrl + ')' }"></div>

  <div class="coupon-row coupon-text coupon-title" [innerHTML]="item.name"></div>
</div>
